export default "__VITE_ASSET__BSw12zJu__"